import { render, staticRenderFns } from "./EmailNotice.vue?vue&type=template&id=04791e66&scoped=true&"
import script from "./EmailNotice.vue?vue&type=script&lang=js&"
export * from "./EmailNotice.vue?vue&type=script&lang=js&"
import style0 from "./EmailNotice.vue?vue&type=style&index=0&id=04791e66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04791e66",
  null
  
)

export default component.exports